import {createAsyncThunk} from '@reduxjs/toolkit';
import {filtersApi} from 'api';
import {IBaseFiltersApiResponse} from 'models';
import {toastNotificationManager} from 'toast-notifications';
import {prefix} from './config';

export const fetchContentItemStatusesThunk: any = createAsyncThunk<IBaseFiltersApiResponse>(
  `${prefix} fetchContentItemStatuses`,
  async (_, {rejectWithValue, dispatch}) => {
    try {
      const {parsedBody} = await filtersApi.getFilterContentItemStatuses();
      return parsedBody;
    } catch (error) {
      dispatch(
        toastNotificationManager.createErrorToastAction(
          error.parsedBody || error.statusText || 'Failed to fetch learning path statuses. Unknown error occurred.'
        )
      );
      return rejectWithValue(error);
    }
  }
);
